import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-fee-collect',
  templateUrl: './fee-collect.component.html',
  styleUrls: ['./fee-collect.component.css']
})
export class FeeCollectComponent {

  @Input() members: IMember[];
  @Output() feeCollection = new EventEmitter<any>();
  loading: false;
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("FeeCollectComponent", label);
  }
  constructor(

    private LanguageService: LanguageService,
  ) {

  }

  feeInvoice() {
    this.feeCollection.emit();
  }

}
